import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

export default function OfflineNotice() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#E50914',
      color: '#fff',
      padding: '12px 24px',
      borderRadius: '8px',
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: 'bold',
      boxShadow: '0 4px 20px rgba(0,0,0,0.7)',
      fontSize: '14px',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <WifiOff size={20} />
      Você está sem conexão com a internet. Verifique seu Wi-Fi ou dados móveis.
    </div>
  );
}